<template>
    <div>
        <page-header :buttons="pageActions.buttons" :additional="pageActions.additional" @method="methodHandler">
            <template slot="title">Permissions</template>
        </page-header>
        <pro-table
            :resource="resource"
            prefix="/configuration/"
            :fields="fields"
            :filters="filters"
            :filters-loading="filtersLoading"
            :limit="50"
            ref="datatable"
            class="px-6 pt-2"
            @action="actionHandler"
            table-class="text-xs"
            sort="name"
            direction="ASC"
            delete-label="name"
            :actions="actions"
        ></pro-table>
    </div>
</template>

<script>
    import DataTableSetup from '../../../mixins/DataTableSetup';

    export default {
        name: "Permissions",
        mixins: [ DataTableSetup ],
        data: function() {
            return {
                resource: 'permissions',
                numberOfFilters: 2,
                pageActions: {
                    buttons: [
                        {
                            label: 'New Permission',
                            icon: 'plus',
                            type: 'router-link',
                            link: '/configuration/permissions/create',
                            iconClass: 'text-green-600'
                        }
                    ],
                    additional: []
                },
                fields: [
                    {
                        name: 'Name',
                        column: 'name',
                        route: '/configuration/permissions/{id}/edit',
                        linked: true,
                        sortCol: 'name'
                    },
                    {
                        name: 'Description',
                        column: 'description',
                    },
                    {
                        name: 'Route / Key',
                        column: 'route',
                    },
                    {
                        name: 'Type',
                        column: 'type.name',
                    },
                    {
                        name: 'Active',
                        column: 'active',
                        boolean: true,
                        toggle: true,
                        align: 'center'
                    },
                    {
                        name: 'Hidden',
                        column: 'hidden',
                        boolean: true,
                        toggle: true,
                        align: 'center'
                    }
                ],
                actions: {
                    display: true,
                    class: [],
                    options: [
                        { label: 'Edit', link: 'edit', icon: 'edit', type: 'router-link', tooltip: 'Edit', permissions: this.resource+'.edit' },
                        { label: 'Delete', method: 'delete', icon: 'trash-alt', type: 'method', tooltip: 'Delete', permissions: this.resource+'.destroy' },
                    ]
                }
            }
        },
        methods: {
            methodHandler: function(method){
                this[method]();
            },
        },
        mounted() {
            //Search Filter
            const searchFilter = {
                label: 'Search',
                name: 'search',
                type: 'text',
                width: 'w-1/4',
                value: this.searchValue,
                placeholder: 'Search...'
            };

            this.filters.push(searchFilter);

            // Types Filter
            const typesFilter = {
                label: 'Type',
                name: 'type',
                type: 'select',
                options: this.$store.getters.permissionTypes.map(function (type) {
                    return { label: type.name, value: type.id };
                }),
                width: 'w-1/4',
                value: this.permissionTypeValue,
                placeholder: 'Select Type...'
            };

            if (this.$store.getters.permissionTypes.length === 0){
                this.$store.dispatch('GET_PERMISSION_TYPES').then(() => {
                    typesFilter.options = this.$store.getters.permissionTypes.map(function (type) {
                        return { label: type.name, value: type.id };
                    });
                    typesFilter.value = this.permissionTypeValue;
                    this.filters.push(typesFilter);
                    this.$Progress.finish();
                });
            } else {
                this.filters.push(typesFilter);
            }
        },
        computed: {
            permissionTypeValue() {
                const filters = this.$store.getters.filters;

                if (!window._.isEmpty(filters.permissions.type)) {
                    return filters.permissions.type;
                } else {
                    return null;
                }
            },
        }
    }
</script>

<style scoped>

</style>
